import React from 'react'

import { writeFile, readFile } from '@utils/fs-helpers'

import {
  getEntity,
  getHeaderData,
  getFooterData,
  getDocumentsProductCategoriesData,
} from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeArchiveDocuments } from '@models/ArchiveDocuments'
import { default as normalizeDocumentProduct } from '@models/DocumentProduct'

import { Col, Container, Row } from '@/atoms/Grid'
import { ArchiveList, ArchiveSidebar } from '@/organisms'

import Layout from '@/organisms/Layout'
import Breadcrumb from '@/molecules/Breadcrumb'

export const getStaticPaths = async () => {
  const documents = await Promise.all(
    [{ entity: 'documents' }].map(({ entity }) => getEntity({ entity }))
  )

  const paths = documents.reduce((acc, { data }) => {
    if (!data) return acc

    const pathData = Array.isArray(data) ? data : [data]
    const paths = pathData.map(({ categories }) => {
      return categories.map(({ slug }) => {
        return {
          params: {
            slug,
          },
        }
      })
    })

    return [...acc, ...paths]
  }, [])

  try {
    const pagesCache = documents.reduce((acc, { data, entity }) => {
      if (!data || data.length === 0) return acc

      const pathData = Array.isArray(data) ? data : [data]
      const paths = pathData.map(({ categories }) => {
        return categories.map(({ slug }) => {
          return {
            slug,
            entity,
          }
        })
      })

      return [...acc, ...paths]
    }, [])

    await writeFile(
      'cache/static-paths-product-documents.json',
      JSON.stringify(...pagesCache),
      'utf-8'
    )
  } catch (error) {
    console.error('Generate cache file error', error)
  }

  return {
    paths: paths[0],
    fallback: false,
  }
}

export const getStaticProps = async ({ params }) => {
  const cacheFile = await readFile(
    'cache/static-paths-product-documents.json',
    'utf-8'
  )
  const staticPaths = JSON.parse(cacheFile)

  const { slug } = staticPaths.find((path) => {
    const slug = Array.isArray(path.slug) ? path.slug.join('/') : path.slug
    return slug === `${params.slug}`
  })

  const [header, footer, data] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getDocumentsProductCategoriesData(),
  ])

  let documents = null
  data.categories.map((el) => {
    if (el.slug == slug) {
      documents = el
      el.isActive = true
    }
  })
  const normalizedDocs = normalizeDocumentProduct(documents)

  return {
    props: {
      metadata: {
        metaTitle: `${normalizedDocs.name} - Categoria Documenti Prodotti`,
      },
      breadcrumb: normalizeBreadcrumb([
        {
          label: 'Set informativi',
          href: '/set-informativi',
        },
        {
          label: normalizedDocs.name,
        },
      ]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveDocuments(data),
      list: {
        entity: 'set-informativi',
        type: 'grid',
        categories: [normalizedDocs],
        backButton: true,
        backButtonLabel: "Torna all'archivio",
      },
    },
  }
}

const CategoryDocumentsProduct = ({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
  list,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='set-informativi'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList {...list} />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default CategoryDocumentsProduct
